import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import ModalAddProduct from './modal/productmodal.vue'
import ActionButtonProduct from './components/ActionButtonProduct.vue'

import CardProductRepository from '@/shared/http/repositories/crm/cardproduct.js'
import { createNewFollowupWithCard } from '@/components/tools/FollowupTools'
import productSituation from '@/enums/enumProductSituation.js'
import cardSituation from '@/enums/enumCardSituation.js'

export default {
  name: 'CrmDetailsProduct',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    boardArchived: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: null,
      form: null,
      products: null,
      hasProducts: false,
      productSituation: productSituation,
      cardSituation: cardSituation,
      columnsBase: [
        this.$lang.Common.DataTable.ProductTable.Date,
        this.$lang.Common.DataTable.ProductTable.Product,
        this.$lang.Common.DataTable.ProductTable.Value,
        this.$lang.Common.DataTable.ProductTable.Observation
      ]
    }
  },
  components: {
    ModalAddProduct, ActionButtonProduct
  },
  computed: {
    totalValue () {
      let result = null
      if (this.objList && this.objList.length > 0) {
        this.objList.forEach(element => {
          result += element.valor
        })
      }
      return result
    },
    cardIsActive () {
      if ((this.card.situacao === this.cardSituation.ATIVO) &&
        (this.card.boardColumn.board.arquivado === false) &&
        (this.card.boardColumn.board.isReadOnly === false)) { return true }
      return false
    },
    columnsVenda () {
      let columns = [...this.columnsBase]
      if (this.cardIsActive) {
        columns.push(this.$lang.Common.DataTable.Actions)
      }
      return columns
    }
  },
  watch: {
    card () {
      if (this.card) {
        this.onLoadAllProducts()
      }
    }
  },
  methods: {
    onLoad () {
      this.onLoadAllProducts()
    },
    onLoadAllProducts () {
      if (this.card) {
        CardProductRepository.Search(this.card.id, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.hasProducts = response.data.content.length > 0
            this.onResultGrid(response)
          })
          .catch(this.onException)
      }
    },
    onAddProduct () {
      this.$refs.ModalAddProduct.showModal()
    },
    onReload () {
      this.onLoadAllProducts()
      this.$emit('Reload')
    },
    destroyModal () {
      this.$refs['ModalAddProduct'].hideModal()
    },
    onDelete (obj) {
      CardProductRepository.Delete(obj.id)
        .then((response) => {
          if (response.status === 200) {
            createNewFollowupWithCard(this.card.pessoa.document, 'sys_produto_excluido', 'O Produto ' + obj.produtoDTO.nome + ' no valor de R$ ' + this.formatValue(obj.valor) + ' foi excluído!', this.ip, this.latitude, this.longitude, this.card.id)
            this.onReload()
          }
        })
        .catch(this.onException)
    },
    onEdit (obj) {
      if (!this.boardArchived) this.$refs.ModalAddProduct.showModal(obj)
    },
    formatValue (value) {
      return Tools.formatMoneyBR(value)
    },
    formatDate (d, hasTime) {
      const date = new Date(d)
      date.setHours(date.getHours() + 3)

      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      return `${day}/${month}/${year}` + (hasTime ? ` às ${hours}:${minutes}` : '')
    },
    checkTypeBoard (card, tipo) {
      if (card && card.boardColumn.board.tipoBoard === tipo) {
        return true
      }
      return false
    },
    textColorProduct (obj) {
      let vendaBoard = obj.cardDTO.boardColumn.board.tipoBoard === 'VENDA'

      if (vendaBoard && obj.situacao === productSituation.GANHO) return 'text-success text-center'
      else if (vendaBoard && obj.situacao === productSituation.PERDIDO) return 'text-danger text-center'
      else return 'text-center'
    },
    actionProduct (obj, actionToPerform) {
      switch (actionToPerform) {
        case productSituation.ATIVO:
          this.resetProduct(obj)
          break
        case productSituation.GANHO:
          this.winProduct(obj)
          break
        case productSituation.PERDIDO:
          this.loseProduct(obj)
          break
        case 'DELETAR':
          this.deleteProduct(obj)
          break
        default:
          console.error('Opção inválida!')
          break
      }
    },
    resetProduct (obj) {
      obj.situacao = productSituation.ATIVO
      CardProductRepository.ChangeStatus(obj.id, obj)
        .then((response) => {
          if (response.status === 200) {
            createNewFollowupWithCard(this.card.pessoa.document, 'sys_produto_reativado', 'O Produto ' + obj.produtoDTO.nome + ' no valor de R$ ' + this.formatValue(obj.valor) + ' foi resetado!', this.ip, this.latitude, this.longitude, this.card.id)
            this.onReload()
          }
        })
        .catch(this.onException)
    },
    winProduct (obj) {
      obj.situacao = productSituation.GANHO
      CardProductRepository.ChangeStatus(obj.id, obj)
        .then((response) => {
          if (response.status === 200) {
            createNewFollowupWithCard(this.card.pessoa.document, 'sys_produto_ganho', 'O Produto ' + obj.produtoDTO.nome + ' no valor de R$ ' + this.formatValue(obj.valor) + ' foi ganho!', this.ip, this.latitude, this.longitude, this.card.id)
            this.onReload()
          }
        })
        .catch(this.onException)
    },
    loseProduct (obj) {
      obj.situacao = productSituation.PERDIDO
      CardProductRepository.ChangeStatus(obj.id, obj)
        .then((response) => {
          if (response.status === 200) {
            createNewFollowupWithCard(this.card.pessoa.document, 'sys_produto_perdido', 'O Produto ' + obj.produtoDTO.nome + ' no valor de R$ ' + this.formatValue(obj.valor) + ' foi perdido!', this.ip, this.latitude, this.longitude, this.card.id)
            this.onReload()
          }
        })
        .catch(this.onException)
    },
    deleteProduct (obj) {
      CardProductRepository.Delete(obj.id)
        .then((response) => {
          if (response.status === 200) {
            createNewFollowupWithCard(this.card.pessoa.document, 'sys_produto_excluido', 'O Produto ' + obj.produtoDTO.nome + ' no valor de R$ ' + this.formatValue(obj.valor) + ' foi excluído!', this.ip, this.latitude, this.longitude, this.card.id)
            this.onReload()
          }
        })
        .catch(this.onException)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/product/product.js